import * as React from 'react';

import initBem from 'js/lib/bem';

import 'css!./__styles__/EmbeddedImage';

import type { EmbeddedContentProps } from './EmbeddedContent';

const bem = initBem('EmbeddedImage');

export const EmbeddedImage = ({ url, title }: EmbeddedContentProps) => {
  return (
    <div className={bem()}>
      <img src={url} alt={title} />
    </div>
  );
};

export const isEmbeddedImage = (url: string) => {
  const regex = /\.(jpeg|jpg|jfif|pjepg|pjp|gif|png|apng|bmp|ico|cur|svg|webp)$/i;

  if (url.match(regex)) {
    return true;
  }

  return false;
};

export default EmbeddedImage;
